import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import React from "react";
import classNames from "classnames";
import getClassNameFactory from "../../utilities/classNames";
import { Alignments } from "../../core";
import { types } from "./HeadingTypes";

var Heading = function Heading(_ref) {
  var _classNames;

  var align = _ref.align,
      children = _ref.children,
      rank = _ref.rank,
      boldOrange = _ref.boldOrange,
      type = _ref.type,
      id = _ref.id,
      className = _ref.className,
      boldType = _ref.boldType,
      role = _ref.role;
  var getClassName = getClassNameFactory(Heading.displayName);
  var HeadingTag = "span";

  if (rank && Object.values(rank).includes(rank)) {
    HeadingTag = "h".concat(rank);
  }

  return /*#__PURE__*/React.createElement(HeadingTag, {
    className: getClassName({
      className: className,
      modifiers: classNames((_classNames = {}, _defineProperty(_classNames, type, true), _defineProperty(_classNames, align, align !== Alignments.LEFT), _defineProperty(_classNames, "boldOrange", boldOrange), _defineProperty(_classNames, boldType, Boolean(boldType)), _classNames)),
      utilities: classNames({
        typographySmallCaps: type === types.SmallCaps
      })
    }),
    id: id,
    role: role
  }, children);
};

Heading.displayName = "Heading";
Heading.defaultProps = {
  align: Alignments.LEFT
};
export default Heading;